export const CONNECTION_TABLE_HEADERS = [
  { text: 'Connection Name' },
  { text: 'Description' },
  { text: 'Last Accessed' },
  { text: 'Connection Type' },
  { text: '' },
];

export const DATASCOPE_TABLE_HEADERS = [
  { text: 'Datascope Name' },
  { text: 'Description' },
  { text: 'Last Accessed' },
  { text: 'Connection' },
  { text: '' },
];

export const REPORT_TABLE_HEADERS = [
  { text: 'Report Name' },
  { text: 'Description' },
  { text: 'Tags' },
  { text: '' },
];

export const REPORT_TEMPLATE_TABLE_HEADERS = [
  { text: 'Template Name' },
  { text: 'Description' },
  { text: 'Template Category' },
  { text: '' },
];

export const CONVERSATIONS_TABLE_HEADERS = [
  { text: 'Conversation Title' },
  { text: 'Last Session Time' },
  { text: '' },
];


export const CANVAS_TABLE_HEADERS = [
  { text: 'Connection Name' },
  { text: 'Description' },
  { text: 'Last Accessed' },
  { text: '' },
];
